import { render } from "./packet_stock.vue?vue&type=template&id=3e17ef91&scoped=true"
import script from "./packet_stock.vue?vue&type=script&lang=js"
export * from "./packet_stock.vue?vue&type=script&lang=js"

import "./packet_stock.vue?vue&type=style&index=0&id=3e17ef91&scoped=true&lang=css"

import exportComponent from "D:\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e17ef91"]])

export default __exports__